<template>
    <div>
        <simple-notification v-if="pending"
            :notification="notification"
            @click.native="open"
        />
        <simple-notification v-else
            :notification="notification"
            class="answered"
        />
        <a-modal 
            :visible="modalVisibility"
            :zIndex="81000"
            :footer="null"
            :closable="false"
            :width="600">

            <user-access-request v-model="level"
                :inviteId="notification.payload.inviteId"
                :requester="notification.payload.user"
                :disabled="disabled"
                @answered="markAsRead"
                @click.stop/>
        
        </a-modal>

    </div>
</template>

<script>
    import firebase from '@/firebase/firebase';
    import UserAccessRequest from '../../components/account/UserAccessRequest.vue'
    import SimpleNotification from './SimpleNotification.vue'

    export default {
        components: {
            UserAccessRequest,
            SimpleNotification
        },
        props: {
            notification: Object
        },
        data() {
            return {
                level: '2',
                modalVisibility: false,
                disabled: false,
                pending: true,
            }
        },
        methods: {
            open () { this.modalVisibility = true; },
            async markAsRead () {
                const companyId = this.$store.getters.getCompanyID;
                const userId = this.$store.getters.getUserStoredData.uid;
                const db = firebase.firestore();
                const ref = await db.collection(`company/${companyId}/companyUsers/${userId}/notifications`).doc(this.notification.id);
                await ref.update({
                    sticky: false
                })
            },
            checkStatus (invite) {
                this.pending = invite.pending;
                this.disabled = false;
                this.modalVisibility = false; // In case is other user with popup opened
            },
            async checkIfAlreadyAnswered () {
                this.disabled = true;
                const db = firebase.firestore();
                const companyId = this.$store.getters.getCompanyID;
                const inviteId = this.notification.payload.inviteId
                await db.collection(`company/${companyId}/invites`).doc(inviteId)
                    .onSnapshot((snapshot) => {
                        const invite = snapshot.data();
                        this.checkStatus(invite);
                    });
            }
        },
        async mounted () {
            await this.checkIfAlreadyAnswered();
        },
    }
</script>

<style scoped>
    .answered {
        opacity: 0.35;
        cursor: initial;
    }
</style>